import React from 'react';
import PropTypes from 'prop-types';

class YGrid extends React.Component {
    static propTypes = {
        chartBoundaries: PropTypes.object.isRequired,
        yValueToSVGCoordinateMapper: PropTypes.func.isRequired,
    }

    render() {
        const {
            chartBoundaries,
            yValueToSVGCoordinateMapper,
        } = this.props;

        return (
            <g
                className={'ygrid'}
            >
                {
                    yValueToSVGCoordinateMapper.ticks().map((value, index) => {
                        return (
                            <line
                                className={'ygrid-line'}
                                stroke='#000'
                                x1={chartBoundaries.left}
                                x2={chartBoundaries.right}
                                y1={yValueToSVGCoordinateMapper(value)}
                                y2={yValueToSVGCoordinateMapper(value)}
                                key={index}
                            />
                        );
                    })
                }

            </g>
        );
    }
};

export default YGrid;
